<drawer [title]="messageType === 'ALERT' ? 'ALERT' : 'Messages'"
        [contextLabel]="messageType === 'ALERT' ? ('Alert' | translate) : ('Message' | translate)"
        [contextVariant]="messageType === 'ALERT' ? 'danger' : 'info'"
        [isClosed]="false" (closeEvent)="closeLayer()" [showHeaderButtons]="false" [noContentPadding]="true">
	<div class="row d-flex align-items-center py-1 list-search-container-zone">
		<div class="col">
            <div class="list-search-container pe-1">
                <i class="fas fa-search list-search-icon"></i>
                    <input type="text"
						(click)="$event.stopPropagation()"
						(input)="searchTextChanged($event.target.value)"
						[(ngModel)]="searchValue"
						placeholder="{{ (messageType === 'MESSAGE' ? 'Search message' : 'Search alert') | translate }}"
						class="form-control list-search-input flex-grow-1">
						<i
                        *ngIf="searchValue"
                        (click)="resetListSearch()"
                        class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
                        aria-hidden="true"
                      ></i>
						<button class="btn btn-sm btn-primary"
						(click)="openEditMessage(false);$event.stopPropagation();"
						placement="left"
						aria-hidden="true">{{'New message' | translate}}</button>
            </div>
        </div>
		<div class="col-auto pl-0">
			<div class="btn-group-primary-light btn-group-toggles btn-group-toggles-small d-inline-flex">
              <button *ngFor="let option of availableChannels" (click)="filterChannel(option.id)"
                  class="btn-group-toggle {{option.id === currentChannel ? 'active' : ''}}" [ngClass]="{'disabled': option.disabled}">
                  <i *ngIf="option.icon" class="far fa-{{option.icon}} mr-1"></i>{{ option.name | translate }}
              </button>
            </div>
		</div>
	</div>
	<div class="list-search-options-zone">
		<div *ngIf="!messages || !messages.length" class="d-flex justify-content-center my-5">
			<i class="fad fa-spinner-third fa-spin align-self-center fa-2x"></i>
		</div>
		<div *ngIf="messages && messages.length" class="expanded-list row px-3 pb-0">
			<div class="col px-4 list-item-container">
				<div *ngFor="let message of messages; let i = index" class="item py-2 row">
					<div class="col-8 col-lg-9 d-flex align-items-center" (click)="openAddStatus(message);">
						<i class="far fa-{{getMessageIcon(message)}} mr-2"></i>
						<span>{{message.subject}}</span>
					</div>
					<div class="col-1 col-lg-1 text-center">
						<span class="badge badge-light"
							tooltipHtml="{{message.messageRoleStatuses && message.messageRoleStatuses.length ? formatUsedNum(message.messageRoleStatuses) : ('None' | translate)}}"
							html=true
							placement="left">{{message.messageRoleStatuses && message.messageRoleStatuses.length || 0}}</span>
					</div>
					<div class="col-3 col-lg-2 text-right">
						<i class="fas fa-pencil btn-xs btn-bordered btn-light btn-icon item-remove mr-2" (click)="openEditMessage(message);$event.stopPropagation();"></i>
						<confirmation-popover
							className="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action"
							(onConfirmed)="deleteMessage(message)"></confirmation-popover>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="row drawer-content-footer m-0">
		<div class="col">
			<div class="app-pagination">
				<ul class="pagination">
					<li class="page-item" *ngIf="page > 2">
						<a class="page-link" (click)="setPage(1)">
							<i class="fal fa-angle-double-left"></i>
						</a>
					  </li>
					  <li class="page-item" *ngIf="page > 1">
						<a class="page-link" (click)="setPage((page - 1))">
							<i class="fal fa-angle-left"></i>
						</a>
					</li>
					<li
						*ngFor="let p of pageNumber()"
						class="page-item"
						[ngClass]="{'hidden': (p !== page)}">
						<span class="page-link disabled" disabled>
							<b>{{p}}</b> of {{pageNumber()[(pageNumber().length - 1)]}}
						</span>
					</li>
					<li class="page-item" *ngIf="page <= (pageNumber().length-1)">
						<a class="page-link" (click)="setPage((page + 1))">
							<i class="fal fa-angle-right"></i>
						</a>
					</li>
					<li class="page-item" *ngIf="page <= pageNumber()[(pageNumber().length - 2)]">
						<a class="page-link" (click)="setPage(pageNumber()[(pageNumber().length - 1)])">
							<i class="fal fa-angle-double-right"></i>
						</a>
					</li>
				</ul>
			</div>
		</div>
	</div>
</drawer>

<drawer *ngIf="topLayer == 'editMessage'"
        [title]="'Edit message'"
        [contextLabel]="message?.subject"
        [contextVariant]="messageType === 'ALERT' ? 'danger' : 'neutral'"
        (saveEvent)="saveEditMessage()" [isClosed]="!editMessage" (closeEvent)="cancelEdit();" [noContentPadding]="true">
	<message-edit class="drawer-content drawer-direct-content px-4 py-4"
		[serviceId]="serviceId"
		[message]="message"
		[isAlert]="messageType === 'ALERT'"
		(editCancel)="cancelEdit();"
		(formSubmit)="messageWindowSubmitted($event);"></message-edit>
</drawer>
